import React, { useContext } from "react";
import ContextComponent from "../../../AppContext";
import FolderNode from "./FolderNode";

const FolderTree = ({
  selectionMode = "single",
  selectedFolderId,
  setSelectedFolderId,
  currentFolderId,
  expandedFolders,
  toggleFolder,
  type,
}) => {
  const { folderStructure } = useContext(ContextComponent);

  let folderTree = folderStructure;

  return (
    <div className="indi-folder-tree-wrapper">
      <div className="indi-folder-tree-content">
        <ul className="indi-folder-tree-content-list">
          {folderTree.map((node) => (
            <FolderNode
              key={node?.id}
              level={0}
              node={node}
              selectionMode={selectionMode}
              selectedFolderId={selectedFolderId}
              setSelectedFolderId={setSelectedFolderId}
              currentFolderId={currentFolderId}
              expandedFolders={expandedFolders}
              toggleFolder={toggleFolder}
              type={type}
            />
          ))}
        </ul>
      </div>
    </div>
  );
};

export default FolderTree;
